import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ConfService} from '../../conf.service';
import {toArray} from 'rxjs/operators';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {MatSnackBar} from '@angular/material';
import {ActivatedRoute} from '@angular/router';
import {MatDialog} from '@angular/material';
import {interval} from 'rxjs';
import {AccountInfoService} from '../../user/account-info.service';

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss']
})
export class IntegrationsComponent implements OnInit {

  loading: boolean;
  componentLoading = true;
  title = 'All API Providers';
  cardType = 'connectorAvl';
  buttonType = 'connector';
  partner: any;
  account: any;
  title1 = 'My API Providers';
  cardType1 = 'connectorSubscribed';
  buttonType1 = 'connector';
  apiProducers = [];
  flag1 = false;
  flag2 = false;
  available = [];
  subscribed = [];
  subscribedTemp = [];
  platformServiceProviders: any;
  partnerServiceProviders: any;
  settingsData: any;

  searchText: any;
  flag = false;
  categories: any;
  category_id: any;
  specificCategory: any;
  specificCategorytemp: any;
  categorytemp: any;
  producers: any;
  producersTemp: any;
  categoriesLoading = true;
  categoryServiceProviders = false;

  filteredSubscribedTemp: any;
  filteredAvailable = this.available;
  serviceProviderCategories: any = [];
  constructor(private route: ActivatedRoute,
              private confPost: ConfService,
              public accountInfoService: AccountInfoService,
              public dialog: MatDialog, public platform: LeftpanelComponent) { }

  getServiceProviders() {
    return new Promise((resolve, reject) => {
      this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=services'  + '&account=services').subscribe(platformProviders => {
        this.platformServiceProviders = platformProviders;
        this.platform.platformServiceProviders = platformProviders;
        this.flag1 = true;
        const iterator = this.platformServiceProviders[Symbol.iterator]();
        while (true) {
          const tempObject = iterator.next();
          if (tempObject.done) {
            break;
          }
          this.apiProducers.push(tempObject.value);
        }
        resolve('success');
      }, error => {
        resolve('failed');
        this.platform.openSnackBar('Error while getting list of service providers for platform: ' + error.error.message, 'Error', {
          duration: 15000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    });
  }

  getPlatformSericeProviders() {
    return new Promise(async (resolve, reject) => {
      if (this.platform.platformServiceProviders !== null && this.platform.platformServiceProviders !== undefined) {
        this.platformServiceProviders = this.platform.platformServiceProviders;
        this.flag1 = true;
        const iterator = this.platformServiceProviders[Symbol.iterator]();
        while (true) {
          const tempObject = iterator.next();
          if (tempObject.done) {
            break;
          }
          this.apiProducers.push(tempObject.value);
        }
        this.getCategories();
        resolve('success');
      } else {
        await this.getServiceProviders();
        this.getCategories();
        resolve('success');
      }
    });
  }

  getPartnerServiceProviders() {
    return new Promise(async (resolve, reject) => {
      if (this.platform.settingsDataWithoutDBRef !== null && this.platform.settingsDataWithoutDBRef !== undefined) {
        this.flag2 = true;
        this.settingsData = this.platform.settingsDataWithoutDBRef;
        if (this.partner !== 'services') {
          if (this.settingsData['body'][0]) {
            this.subscribedTemp = this.settingsData['body'][0]['subscriptions']['providers'];
            let flag = false;
            // for (let i = 0; i < this.apiProducers.length; i++) {
            //   flag = false;
            //   for (let j = 0; j < this.subscribedTemp.length; j++) {
            //     if (this.apiProducers[i].producer === this.subscribedTemp[j].producer) {
            //       flag = true;
            //     }
            //   }
            //   if (flag === false) {
            //     this.available.push(this.apiProducers[i]);
            //   }
            // }
            if (this.apiProducers) {
              this.apiProducers.forEach(apiProducer => {
                flag = false;
                if (apiProducer && apiProducer.producer) {
                  if (this.subscribedTemp) {
                    this.subscribedTemp.forEach(subscribedProducer => {
                      if (subscribedProducer && subscribedProducer.producer) {
                        if (subscribedProducer.producer === apiProducer.producer) {
                          flag = true;
                        }
                      }
                      subscribedProducer['isSubscribed'] = true;
                    });
                    if (flag === false) {
                      apiProducer.isSubscribed = false;
                      this.available.push(apiProducer);
                    }

                  }
                }
              });
            }
          }
        }
        resolve('success');
      } else {
        this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), true).subscribe(settingsData => {
          this.settingsData = settingsData;
          this.platform.settingsData = settingsData;
          this.flag2 = true;
          if (this.partner !== 'services') {
            if (this.settingsData['body'][0]) {
              this.subscribedTemp = this.settingsData['body'][0]['subscriptions']['providers'];
              let flag = false;
              // for (let i = 0; i < this.apiProducers.length; i++) {
              //   flag = false;
              //   for (let j = 0; j < this.subscribedTemp.length; j++) {
              //     if (this.apiProducers[i].producer === this.subscribedTemp[j].producer) {
              //       flag = true;
              //     }
              //   }
              //   if (flag === false) {
              //     this.available.push(this.apiProducers[i]);
              //   }
              // }
              if (this.apiProducers) {
                this.apiProducers.forEach(apiProducer => {
                  flag = false;
                  if (apiProducer && apiProducer.producer) {
                    if (this.subscribedTemp) {
                      this.subscribedTemp.forEach(subscribedProducer => {
                        if (subscribedProducer && subscribedProducer.producer) {
                          if (subscribedProducer.producer === apiProducer.producer) {
                            flag = true;
                          }
                        }
                        subscribedProducer['isSubscribed'] = true;
                      });
                      if (flag === false) {
                        apiProducer.isSubscribed = false;
                        this.available.push(apiProducer);

                      }
                    }
                  }
                });
              }
            }
          }
          resolve('success');
        }, error => {
          resolve('failed');
          this.platform.openSnackBar('Error while getting list of settings data for partner: ' + error.error.message, 'Error', {
            duration: 15000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        });
      }
    });
  }

  getCategories() {
    return new Promise(async (resolve, reject) => {
      this.confPost.getData('services', 'services', 'v1', 'producerCategories', 'partner=services,' + localStorage.getItem('partner') + '&account=services,' + localStorage.getItem('account')).subscribe(response => {
        this.categories = response;
        if (this.apiProducers) {
          let tempVar: any = [];
          for (const item of this.categories) {
            const sp = item['serviceProvider'];
            for (const item1 of sp) {
              const temp = item1['account'];
              for (const apiProducer of this.apiProducers) {
                if (apiProducer['account'] === temp) {
                  if (!tempVar.includes(item)) {
                    tempVar.push(item);
                  }
                }
              }
            }
          }
          this.serviceProviderCategories = tempVar;
          this.categoriesLoading = false;
        }

        this.confPost.getData('services', 'services', 'v1', 'producerCategories', 'partner=services,' + localStorage.getItem('partner') + '&account=services,' + localStorage.getItem('account') + '&dbref=false').subscribe(response1 => {
          this.categorytemp = response1;
          this.route.queryParams.subscribe(params => {
            if (params.partner !== undefined && params.category !== undefined) {
              this.partner = params.partner;
              this.account = params.partner;
              this.category_id = params.category;
              for (let i = 0; i < this.categories.length; i++) {
                if (this.categories[i].id === parseInt(this.category_id, 10)) {
                  this.specificCategory = this.categories[i];
                }
              }
              for (let i = 0; i < this.categorytemp.length; i++) {
                if (this.categorytemp[i].id === parseInt(this.category_id, 10)) {
                  this.specificCategorytemp = this.categorytemp[i];
                }
              }
              this.specificCategory['currentServiceProvider'] = [];
              this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=services,' + localStorage.getItem('partner') + '&account=services,' + localStorage.getItem('account')).subscribe(response => {
                this.producers = response;
                this.producersTemp = JSON.parse(JSON.stringify(this.producers));
                const temp = [];
                let flag: boolean;
                let flag1: boolean;
                for (let k = 0; k < this.producersTemp.length; k++) {
                  flag = false;
                  flag1 = false;
                  for (let i = 0; i < this.specificCategory.serviceProvider.length; i++) {
                    if (this.producersTemp[k].id === this.specificCategory.serviceProvider[i].id) {
                      flag = true;
                    }
                    if (this.producersTemp[k].id === this.specificCategory.serviceProvider[i].id
                        && this.producersTemp[k].account === this.specificCategory.serviceProvider[i].account
                        && this.producersTemp[k].partner === this.specificCategory.serviceProvider[i].partner
                        && this.producersTemp[k].account !== null && this.producersTemp[k].partner !== null) {
                      flag1 = true;
                    }
                  }
                  if (flag === false) {
                    temp.push(this.producersTemp[k]);
                  }
                  if (flag1) {
                    this.specificCategory.currentServiceProvider.push(this.producersTemp[k]);
                  }
                }
                this.producers = temp;
                this.flag = true;

              });
            } else {
              this.category_id = '';
            }
          });
          resolve('success');
        }, error => {
          resolve('success');
        });
      }, error => {
        resolve('success');
      });
    });
  }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.partner = localStorage.getItem('partner');
    localStorage.removeItem('producer');
    localStorage.removeItem('connectorConfigurationMode');

    const permissionSubscription = interval(500).subscribe((async x => {
      permissionSubscription.unsubscribe();
      Promise.all([this.getPlatformSericeProviders(), this.getPartnerServiceProviders()]).then(response => {
        this.componentLoading = false;
      });
    }));
  }

  stringifyjson(val) {
    return JSON.stringify(val);
  }

  displayAllServiceProviders() {
    this.categoryServiceProviders = false;
  }

  displayServiceProviders(cat) {
    this.categoryServiceProviders = true;
    this.loading = false;
    this.specificCategory = [];
    for (let i = 0; i < this.categories.length; i++) {
      if (this.categories[i].id === parseInt(cat.id, 10)) {
        this.specificCategory = this.categories[i];
      }
    }
    this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=services,' + localStorage.getItem('partner') + '&account=services,' + localStorage.getItem('account')).subscribe(response => {
      this.specificCategory['currentServiceProvider'] = [];
      this.producers = response;
      this.producersTemp = JSON.parse(JSON.stringify(this.producers));
      const temp = [];
      let flag: boolean;
      let flag1: boolean;
      for (let k = 0; k < this.producersTemp.length; k++) {
        flag = false;
        flag1 = false;
        for (let i = 0; i < this.specificCategory.serviceProvider.length; i++) {
          if (this.producersTemp[k].id === this.specificCategory.serviceProvider[i].id) {
            flag = true;
          }
          if (this.producersTemp[k].id === this.specificCategory.serviceProvider[i].id
              && this.producersTemp[k].account === this.specificCategory.serviceProvider[i].account
              && this.producersTemp[k].partner === this.specificCategory.serviceProvider[i].partner
              && this.producersTemp[k].account !== null && this.producersTemp[k].partner !== null) {
            flag1 = true;
          }
        }
        if (flag === false) {
          temp.push(this.producersTemp[k]);
        }
        if (flag1) {
          this.specificCategory.currentServiceProvider.push(this.producersTemp[k]);
        }
      }
      this.producers = temp;
      this.flag = true;
      this.loading = true;
      this.filteredSubscribedTemp = this.specificCategory.currentServiceProvider;
      this.filteredAvailable = this.specificCategory.currentServiceProvider;
      this.filteredSubscribedTemp =  this.filteredSubscribedTemp ? this.filteredSubscribedTemp.filter(({ producer: producerName1 }) => this.subscribedTemp.some(({ producer: producerName2 }) => producerName1 === producerName2)) : [];
      this.filteredSubscribedTemp.forEach(obj => {
        obj['isSubscribed'] = true;
      });
      this.filteredAvailable =  this.filteredAvailable ? this.filteredAvailable.filter(({ producer: producerName1 }) => this.available.some(({ producer: producerName2 }) => producerName1 === producerName2)) : [];
      this.filteredAvailable.forEach(obj => {
        obj['isSubscribed'] = false;
      });
    });
  }

  colorChange(e) {
    if (document.querySelector('#dropdown-list a.active') !== null) {
      document.querySelector('#dropdown-list a.active').classList.remove('active');
    }
    e.target.className = 'list-group-item list-group-item-action active';
  }

  removeColor($event: MouseEvent) {
    if (document.querySelector('#dropdown-list a.active') !== null) {
      document.querySelector('#dropdown-list a.active').classList.remove('active');
    }
  }

  createPaddingRight() {
    document.getElementById('view:providers').style.paddingRight = '400px';
  }

  removePaddingRight() {
    document.getElementById('view:providers').style.paddingRight = '0px';
  }
}
